import React from 'react';

const Title = ({ title, children }) => (
  <span className='sisp-page-title'>{title || children }</span>
);
export default Title;
